import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Section, SectionHeading, CTAButton } from './shared';
// 10 — FLAGSHIP ROAD ACCIDENT SECTION · [Conversion] [SEO/GEO]
// Commercial priority. Links to a dedicated road-accident hub, not generic contact.
const routes = [{
  label: 'Car drivers',
  href: '/road-accidents/car-accident-claims/'
}, {
  label: 'Passengers',
  href: '/road-accidents/passenger-injury-claims/'
}, {
  label: 'Motorcycle riders',
  href: '/road-accidents/motorcycle-accident-claims/'
}, {
  label: 'Cyclists',
  href: '/road-accidents/cyclist-accident-claims/'
}, {
  label: 'Pedestrians',
  href: '/road-accidents/pedestrian-accident-claims/'
}, {
  label: 'Truck / heavy vehicle incidents',
  href: '/road-accidents/truck-accident-claims/'
}, {
  label: 'Hit-and-run or unidentified vehicles',
  href: '/road-accidents/hit-and-run-claims/'
}, {
  label: 'Fatal / dependency claims',
  href: '/road-accidents/fatal-accident-claims/'
}];
const mayCover = ['Medical treatment and rehabilitation costs', 'Lost income and reduced earning capacity', 'Care, assistance and support needs', 'Pain and other losses, subject to eligibility'];
export function RoadAccidentFeature() {
  return <Section className="bg-canvas" data-id="element-314">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1fr] lg:gap-14" data-id="element-315">
        <div data-id="element-316">
          <SectionHeading eyebrow="Road accidents" title="Injured in a WA Road Accident?" intro="Whether you were driving, riding, cycling, walking or travelling as a passenger, you may be able to claim. Select who you were at the time of the accident." data-id="element-317" />

          <ul className="mt-6 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-318">
            {routes.map(r => <li key={r.label} data-id="element-319">
                <a href={r.href} className="group flex items-center justify-between gap-2 rounded-btn border border-ink/8 bg-paper px-4 py-3 text-body text-ink shadow-card transition-all duration-200 hover:-translate-y-0.5 hover:text-forest focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal" data-id="element-320">
                  <span data-id="element-321">{r.label}</span>
                  <ArrowRightIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-signal transition-transform group-hover:translate-x-1" strokeWidth={1.75} data-id="element-322" />
                </a>
              </li>)}
          </ul>

          <div className="mt-8" data-id="element-323">
            <CTAButton href="/car-accident-lawyers-perth/" className="px-7" data-id="element-324">
              Check My Road Accident Claim
            </CTAButton>
          </div>
        </div>

        {/* What compensation may cover */}
        <div className="rounded-card border border-ink/5 bg-paper p-7 shadow-card md:p-9" data-id="element-325">
          <h3 className="text-h4 font-semibold text-ink" data-id="element-326">
            What road-accident compensation may cover
          </h3>
          <ul className="mt-6 space-y-4" data-id="element-327">
            {mayCover.map(item => <li key={item} className="flex items-start gap-3" data-id="element-328">
                <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-forest/10 text-forest" data-id="element-329">
                  <CheckIcon aria-hidden="true" className="h-3.5 w-3.5" strokeWidth={2.25} data-id="element-330" />
                </span>
                <span className="text-body text-ink" data-id="element-331">{item}</span>
              </li>)}
          </ul>
          <p className="mt-6 text-small text-slate/70" data-id="element-332">
            What you can claim depends on the circumstances and applicable law.
            Time limits can apply.
          </p>
        </div>
      </div>
    </Section>;
}